import React from "react";
import LogoutTimer from "./LogoutTimer";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const temp = localStorage.getItem("customerid");

  if (!temp || temp === null || undefined) {
    return <Navigate to={`/auth/sso-login`} />;
  }
  return (
    <>
      {children}
      <LogoutTimer />
    </>
  );
};

export default ProtectedRoute;
